<button type="button" [ngClass]="['label', validityData!.state]" [matMenuTriggerFor]="menu">
  {{ validityData!.state | uppercase }}
  <div class="label-date" *ngIf="validityData!.state === 'stopped'">
    {{
      validityData!.end?.day +
        " " +
        (getMonth(validityData!.end!.month!) | date : "MMM") +
        " " +
        validityData!.end?.year
    }}
  </div>
  <div class="label-date" *ngIf="validityData!.state === 'pending'">
    {{
      validityData!.start?.day +
        " " +
        (getMonth(validityData!.start!.month!) | date : "MMM") +
        " " +
        validityData!.start?.year
    }}
  </div>
</button>

<mat-menu  #menu="matMenu" >
  <mat-list *ngIf="validityData && validityData!.state !== 'missing'" >
    <mat-list-item>
      <mat-icon matListAvatar>language</mat-icon>
      <h3 matLine>Time Zone</h3>
      <span matLine>
      {{ validityData.timezone?.value }}{{ validityData.timezone?.offset ? ' - '+validityData.timezone?.offset : '' }}
      </span>
    </mat-list-item>
    <mat-list-item>
      <mat-icon matListAvatar>hourglass_top</mat-icon>
      <h3 matLine>Start date</h3>
      <span matLine>
        <mat-icon *ngIf="!validityData?.start?.date">all_inclusive</mat-icon>
        <ng-container *ngIf="validityData?.start?.date">
          {{
            validityData.start?.day +
              " " +
              (getMonth(validityData.start!.month!) | date : "MMM") +
              " " +
              validityData.start?.year
          }} - {{validityData.start?.time}}
        </ng-container>
      </span>
    </mat-list-item>
    <mat-list-item>
      <mat-icon matListAvatar>hourglass_bottom</mat-icon>
      <h3 matLine>End date</h3>
      <span matLine>
        <mat-icon *ngIf="!validityData?.end?.date">all_inclusive</mat-icon>
        <ng-container *ngIf="validityData?.end?.date">
          {{
            validityData.end?.day +
              " " +
              (getMonth(validityData.end!.month!) | date : "MMM") +
              " " +
              validityData.end?.year
          }} - {{validityData.end?.time}}
        </ng-container>
      </span>
    </mat-list-item>
  </mat-list>
</mat-menu>
